import React, { useState } from 'react';
import { Form, Button, Container, Row, Col } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import '../AdminLogin/AdminLogin.css';
import { useNavigate } from 'react-router-dom';
import img from '../../assets/images/logowithsideimg.png'

function AdminLogin() {
    const [credentials, setCredentials] = useState({ email: '', password: '' });
    const navigate = useNavigate();

    const handleSubmit = (event) => {
        event.preventDefault();
        const { email, password } = credentials;
        const adminEmail = 'admin@gmail.com';
        const adminPassword = 'Admin123';

        if (email === adminEmail && password === adminPassword) {
            localStorage.setItem('isLoggedIn', 'true');
            // Simulating authentication and setting session storage
            toast.success('Login Successful!');
            setTimeout(() => {
                navigate('/Dashboard');  // Redirects user to the admin dashboard
            }, 2000);  // Delay to allow the toast to be seen
        } else {
            toast.error('Invalid email or password');
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setCredentials(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    return (
        <Container className="d-flex vh-100" style={{
            // backgroundImage: 'url(https://www.badskullgaming.com/static/media/logowithsideimg.d391825a8851e2c4b5f3.png)',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
        }}>
            <img src={img} alt="anas was here" className='position-fixed top-50 left-50 translate-middle-y translate-middle-x z-1' style={{ transform: 'translateY(-45%)' }} />
            <Row className="m-auto align-self-center w-100 position-relative z-2">
                <Col xs={12} md={6} lg={4} className="m-auto">
                    <Form onSubmit={handleSubmit} className="p-4 border rounded bg-dark text-light">
                        <h2 className="mb-3 text-center" style={{ color: '#AFDDEA' }}>Admin Login</h2>
                        <Form.Group controlId="formBasicEmail">
                            <Form.Label>Email address</Form.Label>
                            <Form.Control
                                type="email"
                                placeholder="Enter email"
                                value={credentials.email}
                                onChange={handleChange}
                                name="email"
                            />
                        </Form.Group>
                        <Form.Group controlId="formBasicPassword" className="mt-3">
                            <Form.Label>Password</Form.Label>
                            <Form.Control
                                type="password"
                                placeholder="Password"
                                value={credentials.password}
                                onChange={handleChange}
                                name="password"
                            />
                        </Form.Group>
                        <Button style={{ backgroundColor: '#AFDDEA', borderColor: '#AFDDEA', color: 'var(--bs-white)' }} type="submit" className="mt-3 w-100">
                            Login
                        </Button>
                    </Form>
                </Col>
            </Row>
            <ToastContainer position="top-center" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </Container>
    );
}

export default AdminLogin;
